import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledMultiContentPage, StyledPageItem, StyledPaper, StyledTitle } from "./styled";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useLanguage } from "@/context/LanguageContext";
import { RoutesList, buildPath } from "@/routes/routesList";
var MultiContentView = function (_a) {
    var title = _a.title;
    var navigate = useNavigate();
    var intl = useIntl();
    var language = useLanguage().language;
    var pages = [
        {
            name: intl.formatMessage({ id: "title.faqBankStatementProcessing" }),
            path: buildPath(language, RoutesList.FAQBankStatementProcessing)
        },
        {
            name: intl.formatMessage({ id: "title.faqTaxableIncome" }),
            path: buildPath(language, RoutesList.FAQTaxableIncome)
        },
        {
            name: intl.formatMessage({ id: "title.faqReliefGuide" }),
            path: buildPath(language, RoutesList.FAQReliefGuide)
        },
        {
            name: intl.formatMessage({ id: "title.faqTaxImplications" }),
            path: buildPath(language, RoutesList.FAQTaxImplications)
        },
        {
            name: intl.formatMessage({ id: "title.faqBestSoftware" }),
            path: buildPath(language, RoutesList.FAQBestSoftware)
        },
        {
            name: intl.formatMessage({ id: "title.faqReferal" }),
            path: buildPath(language, RoutesList.FAQReferal)
        },
    ];
    return _jsxs(StyledMultiContentPage, { children: [_jsx(StyledTitle, { children: title }), _jsx(StyledPaper, { children: pages.map(function (page) {
                    return _jsx(StyledPageItem, { onClick: function () { return navigate(page.path); }, children: page.name }, page.name);
                }) })] });
};
export default MultiContentView;
